import { render, staticRenderFns } from "./menu-edit.vue?vue&type=template&id=66bf0775&scoped=true&"
import script from "./menu-edit.vue?vue&type=script&lang=js&"
export * from "./menu-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bf0775",
  null
  
)

export default component.exports